import React from "react";
import { Box, Typography, Chip, Tooltip, IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { ServiceModule } from "../../../types/serviceModuleTypes";
import {
  ItemCard,
  ItemHeader,
  ItemMeta,
  ColorDot,
  MetaRow,
} from "./EmployeePageWidgets.styles";
import { useTranslation } from "react-i18next";

interface Props {
  module: ServiceModule;
}

const ServiceModuleItem: React.FC<Props> = ({ module }) => {
  const { t } = useTranslation();
  return (
    <ItemCard>
      <ItemHeader>
        <Box display="flex" alignItems="center" gap={1}>
          <ColorDot sx={{ bgcolor: module.colorHex || undefined }} />
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
            {module.name}
          </Typography>
          <Chip label={module.type} size="small" variant="outlined" />
        </Box>

        <Tooltip title={module.isVisible ? "Visible" : "Hidden"} arrow>
          <IconButton size="small" disableRipple sx={{ p: 0.25 }}>
            {module.isVisible ? (
              <VisibilityIcon fontSize="small" color="success" />
            ) : (
              <VisibilityOffIcon fontSize="small" color="disabled" />
            )}
          </IconButton>
        </Tooltip>
      </ItemHeader>

      <ItemMeta>
        {module.type === "File" && (
          <MetaRow>
            <Typography variant="caption">File</Typography>
            <Typography variant="body2">
              {(module as any).filename ? (
                <a
                  href={(module as any).path}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "inherit", textDecoration: "underline" }}
                >
                  {(module as any).filename}
                </a>
              ) : (
                "—"
              )}
            </Typography>
          </MetaRow>
        )}

        {module.type === "Folder" && (
          <MetaRow>
            <Typography variant="caption">Children</Typography>
            <Typography variant="body2">
              {(module as any).children?.length ?? 0}
            </Typography>
          </MetaRow>
        )}

        {module.type === "Calendar" && (
          <MetaRow>
            <Typography variant="caption">{t("serviceModulesPage.areBirthdaysVisible")}</Typography>
            <Typography variant="body2">
              {(module as any).areBirthdaysVisible ? "Yes" : "No"}
            </Typography>
          </MetaRow>
        )}

        {module.type === "Calendar" && (
          <MetaRow>
            <Typography variant="caption">{t("serviceModulesPage.areAnniversariesVisible")}</Typography>
            <Typography variant="body2">
              {(module as any).areAnniversariesVisible ? "Yes" : "No"}
            </Typography>
          </MetaRow>
        )}
      </ItemMeta>
    </ItemCard>
  );
};

export default ServiceModuleItem;
